import React, { useState } from 'react';
import { FaPlus, FaPencilAlt, FaTimes, FaMapMarkerAlt } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './AssetDetail.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import { useToasts } from 'react-toast-notifications';
import { API } from 'aws-amplify';
import AssetInfo from './AssetInfo/AssetInfo';

const AssetDetail = (props) => {
    const { t } = useI18n();
    const [show, setShow] = useState(false);
    const [asset, setAsset] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { addToast } = useToasts();

    const handleDelete = (assetId) => {
        setShow(false);
        API.put('assets', '/' + assetId, {
            body: {
                paramName: 'asset_active',
                paramValue: false
            },
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                },
        })
        .then(response => {
            addToast(t('assets.deleted'), { appearance: 'success' });
            props.history.push('/assets');
        }).catch(error => {
            console.log(error)
            addToast(t('assets.deleteError'), { appearance: 'error' });
        });
    }

        const isHigh = asset && asset.hp_site === true;

        return (
            <div className="AssetDetail">
                <PageHeader
                    title={
                        <>
                            <h1 className="header-title">{t('pages.assetDetails.title')}</h1>
                            {asset && asset.site_ref && (
                                <span className="asset-ref-mark">{asset.site_ref}</span>
                            )}
                        </>
                    }
                    pageTitle={asset && asset.site_ref ? t('pages.assetDetails.pageTitle', { ref: asset.site_ref }) : t('pages.assetDetails.title')}
                    breadcrumbs={[
                        { label: t('nav.assets'), path: '/assets' },
                        { label: asset?.site_ref || t('common.details') },
                    ]}
                    backTo="/assets"
                    backLabel={t('nav.assets')}
                    statusBadge={
                        <>
                            {asset && asset.type ? <span className="type-badge">{asset.type}</span> : null}
                            {asset ? (
                                <span className={`status-badge ${isHigh ? 'is-high' : 'is-low'}`}>
                                    {isHigh ? t('pages.assetDetails.highPriority') : t('pages.assetDetails.lowPriority')}
                                </span>
                            ) : null}
                        </>
                    }
                    subtitle={
                        (asset && (asset.site_address || asset.district)) ? (
                            <span className="subtitle-item">
                                <FaMapMarkerAlt />
                                {asset.site_address || ''}
                                {asset.site_address && asset.district ? ' · ' : ''}
                                {asset.district || ''}
                            </span>
                        ) : null
                    }
                    actions={
                        <div className="asset-header-actions">
                            <Button
                                variant="primary"
                                size="sm"
                                className="task-action-btn"
                                onClick={() => { props.history.push("/task_asset_add/" + props.match.params.id); }}
                            >
                                <FaPlus /> {t('tasks.addTask')}
                            </Button>
                            <Button
                                variant="success"
                                size="sm"
                                className="task-action-btn"
                                onClick={() => { props.history.push("/asset_add/" + props.match.params.id); }}
                            >
                                <FaPencilAlt /> {t('common.edit')}
                            </Button>
                            <span className="task-action-split" aria-hidden="true" />
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="task-action-btn task-action-delete"
                                onClick={handleShow}
                            >
                                <FaTimes /> {t('actions.delete')}
                            </Button>
                        </div>
                    }
                />
                <div className="div-content">
                    <AssetInfo key="info" onAssetLoaded={setAsset} {...props} />
                </div>
                <Modal className="text-dark border-danger" show={show} onHide={handleClose} animation={false} >
                    <Modal.Header className="bg-danger text-light align-content-center" closeButton>
                    <Modal.Title><h4><strong>{t('assets.deleteTitle')}</strong></h4></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{t('assets.deleteConfirm')}</Modal.Body>
                    <Modal.Footer>
                    <Button className="m-0 mr-2" variant="danger" onClick={() => {handleDelete(props.match.params.id)}}>
                        {t('actions.delete')}
                    </Button>
                    <Button className="m-0"  variant="secondary" onClick={handleClose}>
                        {t('common.close')}
                    </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );

}



export default AssetDetail;
